<template>
  <div>
    <div class="stored_value_card_box">
      <div class="stored_value_card_title">我的储值</div>
      <div class="stored_value_card_num">{{total}}<span style="font-size:18px;color:#666;">&nbsp;&nbsp;张</span></div>
    </div>
    <div class="stored_value_card_content">
      <div class="stored_value_card_content_title clearfix_">
        <p class="fl">储值卡名称</p>
        <p class="fl">储值卡类型</p>
        <p class="fl">剩余金额/次数</p>
        <p class="fl">过期时间</p>
        <p class="fl">操作</p>
      </div>
      <ul>
        <li v-for="(item,index) in storedValueCardList" :key="index" class="clearfix_">
          <p class="fl">{{item.name}}</p>
          <p class="fl">{{item.type==1?'币卡':'次卡'}}</p>
          <p class="fl">{{item.last_sale_money}}{{item.type==1?'元':'次'}}</p>
          <p class="fl">{{item.pass_date}}</p>
          <p class="fl">
            <el-switch v-show="!item.isDefault" class="radio_" @change="changeDefault(item.status,item.sellId)" v-model="item.isDefault" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            <span v-show="item.isDefault">已开启</span>
          </p>
        </li>
        <li v-show="noData"><p>暂无数据</p></li>
      </ul>
      <div class="stored_value_card_pages">
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="storedValueCardPage"
            :page-size="20"
            layout="prev, pager, next, jumper"
            :total="this.total">
          </el-pagination>
        </div> 
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return{
      storedValueCardPage:1,
      storedValueCardList:[],
      total:0,
      noData:false,
    }
  },
  mounted:function(){
    this.getStoredValueCard(this.storedValueCardPage)
  },
  methods:{
    changeDefault:function(status,id){
      var t_=this
      if(status==1)return
      var data=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:id,
        status:1
      })
      axios.post(`${ip}MemberCardRuleInterface/updateCard`,data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.storedValueCardList=[]
          t_.storedValueCardPage=1
          t_.getStoredValueCard(t_.storedValueCardPage)
        }
      })
    },
    handleSizeChange(val){

    },
    handleCurrentChange(val) {
      this.storedValueCardPage=val
      this.storedValueCardList=[]
      this.getStoredValueCard(val)
    },
    getStoredValueCard:function(page){
      var t_=this
      var data={
        channel:2,
        tamp:localStorage.tamp?localStorage.tamp:'',
        page:page,
        pagesize:20,
        tenantId:t_.$route.query.tenantId,
        memberCardId:t_.$route.query.memberCardId
      }
      data=Qs.stringify(data)
      axios.post(`${ip}MemberCardRuleInterface/listRuleDetail`,data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          if(res.data.rows.length==0){
            t_.noData=true
          }else{
            t_.noData=false
            t_.total=res.data.total
            res.data.rows.forEach(function(item,index){
              if(item.status==3||item.status==4){
                t_.$set(item,'isDefault', false)
              }else{
                t_.$set(item,'isDefault', true)
              }
            },t_)
            t_.storedValueCardList=res.data.rows
          }
        }
      })
    }
  }
}
</script>
<style>
  .stored_value_card_box{
    width: 1070px;
    background: #fff;
    height: 125px;
    padding-top: 25px;
    margin-bottom: 10px;
  }
  .stored_value_card_title{
    font-size: 18px;
    color: #666;
    margin-left: 22px;
    margin-bottom: 36px;
  }
  .stored_value_card_num{
    color:#e1251c;
    font-size: 34px;
    margin-left: 126px;
  }
  .stored_value_card_content{
    width: 1070px;
    background: #fff;
  }
  .stored_value_card_content_title{
    border-bottom: 1px solid #b0b0b0;
  }
  .stored_value_card_content_title p{
    width: 20%;
    text-align: center;
    height: 57px;
    line-height: 57px;
  }
  .stored_value_card_content>ul>li{
    border-bottom: 1px solid #e1e1e1;
  }
  .stored_value_card_content>ul>li>p{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    width: 20%;
    text-align: center;
    height: 57px;
    line-height: 57px;
  }
  .stored_value_card_content>ul>li:last-child p{
    width: 100%;
  }
  .stored_value_card_pages{
    margin-top: 10px;
    padding-bottom: 10px;
    text-align: center;
  }
  .stored_value_card_pages .el-pagination__jump{
    margin-top: -9px;
  }
  .stored_value_card_pages .el-pagination__editor{
    top:8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/member/stored_value_card.vue